module.exports = __webpack_public_path__ + "img/circle.8c58bcf6.png";